<div class="data-model-customization-section">
    <div class="row section-header">
        <div class="col-md-4 section-title">
            {{ section.name }}
        </div>
        <div class="col-md-8">
            <div class="field-info">
                <span class="count-text" *ngIf="section.id">Total Added Fields<span class="count"><b>{{
                            count
                            }}</b></span></span>
                <span class="count-text" *ngIf="!section.id">Total Fields<span class="count"><b>{{
                            count
                            }}</b></span></span>
                <button class="section-button transparent-button" (click)="addNewFieldOpened = true" *ngIf="section.id">
                    {{ 'DATA_MODEL_CUSTOMIZATION.ADD_FIELD' | translate }}
                </button>
                <button class="transparent-button square-action-button" *ngIf="section.id" (click)="onEdit()">
                    <svg width="18" height="18" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M11.25 4.25229L13.25 2.25229C14.4926 1.00965 16.5074 1.00965 17.75 2.25229C18.9926 3.49493 18.9926 5.50965 17.75 6.75229L15.75 8.75232M11.25 4.25229L1.33579 14.1665C0.96071 14.5416 0.75 15.0503 0.75 15.5807V19.2523H4.42157C4.95201 19.2523 5.46071 19.0416 5.83579 18.6665L15.75 8.75232M11.25 4.25229L15.75 8.75232"
                            stroke="#17171A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
                <button class="transparent-button square-action-button" *ngIf="section.id" data-bs-toggle="modal" [attr.data-bs-target]="'#deleteSectionDefinition-' + section.id">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.75 5C2.33579 5 2 5.33579 2 5.75C2 6.16421 2.33579 6.5 2.75 6.5V5ZM21.25 6.5C21.6642 6.5 22 6.16421 22 5.75C22 5.33579 21.6642 5 21.25 5V6.5ZM10.5 10.75C10.5 10.3358 10.1642 10 9.75 10C9.33579 10 9 10.3358 9 10.75H10.5ZM9 16.25C9 16.6642 9.33579 17 9.75 17C10.1642 17 10.5 16.6642 10.5 16.25H9ZM15 10.75C15 10.3358 14.6642 10 14.25 10C13.8358 10 13.5 10.3358 13.5 10.75H15ZM13.5 16.25C13.5 16.6642 13.8358 17 14.25 17C14.6642 17 15 16.6642 15 16.25H13.5ZM15.1477 5.93694C15.2509 6.33808 15.6598 6.57957 16.0609 6.47633C16.4621 6.37308 16.7036 5.9642 16.6003 5.56306L15.1477 5.93694ZM4.00156 5.79829L4.82047 18.4914L6.31736 18.3949L5.49844 5.70171L4.00156 5.79829ZM8.56269 22H15.4373V20.5H8.56269V22ZM19.1795 18.4914L19.9984 5.79829L18.5016 5.70171L17.6826 18.3949L19.1795 18.4914ZM19.25 5H4.75V6.5H19.25V5ZM2.75 6.5H4.75V5H2.75V6.5ZM19.25 6.5H21.25V5H19.25V6.5ZM15.4373 22C17.4146 22 19.0522 20.4647 19.1795 18.4914L17.6826 18.3949C17.6063 19.5788 16.6237 20.5 15.4373 20.5V22ZM4.82047 18.4914C4.94777 20.4647 6.58535 22 8.56269 22V20.5C7.37629 20.5 6.39374 19.5788 6.31736 18.3949L4.82047 18.4914ZM9 10.75V16.25H10.5V10.75H9ZM13.5 10.75V16.25H15V10.75H13.5ZM12 3.5C13.5134 3.5 14.7868 4.53504 15.1477 5.93694L16.6003 5.56306C16.0731 3.51451 14.2144 2 12 2V3.5ZM8.85237 5.93694C9.21319 4.53504 10.4867 3.5 12 3.5V2C9.78568 2 7.92697 3.51451 7.39971 5.56306L8.85237 5.93694Z" fill="#17171A" fill-opacity="0.9"/>
                    </svg>

                </button>
                <button class="transparent-button square-action-button" (click)="sectionExpanded = true"
                    *ngIf="!sectionExpanded">

                    <svg *ngIf="!sectionExpanded" width="10" height="6" viewBox="0 0 10 6" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L5 5L9 1" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </button>
                <button class="transparent-button square-action-button" (click)="sectionExpanded = false"
                    *ngIf="sectionExpanded">

                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 5L5 1L1 5" stroke="#17171A" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="sectionExpanded" @slideToggle
        [ngClass]="{' attribute-section': section.attributeDefinitions.length > 0}" cdkDropList
        (cdkDropListDropped)="onDrop($event)" [cdkDropListData]="section.attributeDefinitions"
        [cdkDropListDisabled]="!section.id">
        <div *ngFor="let attr of section.attributeDefinitions; trackBy: trackById" cdkDrag
            [cdkDragDisabled]="!section.id">
            <lib-data-model-customization-attribute [attribute]="attr" [showVoltageClass]="showVoltageClass" (editClicked)="editAttribute($event)"
                (deleteClicked)="deleteAttribute($event)"
                (toggled)="save(false, true)" *ngIf="!attr.parentAttributeId"></lib-data-model-customization-attribute>
            <div class="drag-preview" *cdkDragPreview>
                {{ attr.label }}
            </div>

            <div class="drag-placeholder" *cdkDragPlaceholder></div>
        </div>
    </div>
</div>
<ng-container *ngIf="addNewFieldOpened">
    <div class="modal-backdrop">
        <div class="modal-window">
            <lib-add-new-network-device-field (closeModalEvent)="addNewFieldOpened = false; editAttrId = 0"
                [attributes]="section.attributeDefinitions" [attrId]="editAttrId" [showVoltageClass]="showVoltageClass" (saved)="save()">
            </lib-add-new-network-device-field>
        </div>
    </div>
</ng-container>

<lib-add-new-section *ngIf="isEditOpened" [assetType]="assetType" [section]="sectionToEdit" [utilityId]="utilityId" (closeModal)="isEditOpened = false" [isEdit]="true" (updated)="onSectionUpdated()"></lib-add-new-section>

<div
  class="modal fade"
  [attr.id]="'deleteSectionDefinition-' + section.id"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content delete-modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header delete-modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          {{ "CRUD.ARE_YOU_SURE_DELETE" | translate}} {{ "COMMON.SECTION_DEFINITION" | translate}}?
        </h5>
      </div>
      <div class="modal-footer delete-modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-bs-dismiss="modal"
          (click)="onDelete()"
        >
          {{ "COMMON.DELETE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>